import React from 'react';
import '../styles/Post.css';

/**
 * Renders text content, handling segments with hyperlinks if present
 */
function renderTextContent(item) {
  // If segments exist, render them (contains links)
  if (item.segments && item.segments.length > 0) {
    return item.segments.map((segment, segIndex) => {
      if (segment.type === 'link') {
        return (
          <a 
            key={segIndex}
            href={segment.url}
            target="_blank"
            rel="noopener noreferrer"
            className="post-link"
          >
            {segment.text}
          </a>
        );
      }
      // Regular text segment
      return <span key={segIndex}>{segment.value}</span>;
    });
  }
  
  // No segments, just return plain text
  return item.text;
}

function Post({ post }) {
  return (
    <div className="post">
      <div className="post-content">
        {post.title && <h2 className="post-title">{post.title}</h2>}
        {post.date && <div className="post-date">{post.date}</div>}
        
        <div className="post-body">
          {post.content.map((item, index) => {
            if (item.type === 'paragraph') {
              return (
                <p 
                  key={index} 
                  className={`post-paragraph post-${item.align}`}
                >
                  {renderTextContent(item)}
                </p>
              );
            } else if (item.type === 'footnote') {
              return (
                <p 
                  key={index} 
                  className={`post-footnote post-${item.align}`}
                >
                  {renderTextContent(item)}
                </p>
              );
            }
            return null;
          })}
        </div>
      </div>
    </div>
  );
}

export default Post;

